export default "__VITE_ASSET__DLxmmY0r__"